module.exports = __webpack_public_path__ + "static/media/jinx.23b032db.png";